// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrCrudUrl } from '../../../settings'
import { showToast } from '../../../utils/utils'

const getReportList = async (patientId) => {
  const fileBaseUrl = `${ehrCrudUrl}/report-store/patient-identifier/`

  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const showMissingFiles = false // only show reports with metadata and files
    const url = `${fileBaseUrl}${patientId.value}?show_missing_files=${showMissingFiles}&report_ordering=creation_date`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      showToast('error', `Error with network request: ${response.status}`)
      return []
    }
    const result = await response.json()

    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    store.dispatch('reportCount', result.reports.length)

    return result.reports
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log(`error: status=${e.status}`)
    }
    showToast('error', `Error with network request: ${e.status}`)
  }
  return []
}

export default getReportList
